import React from 'react';
import { Page, Text, View, Document } from '@react-pdf/renderer';
import Image from '../../common/PDF/Image';
import styles from '../../common/PDF/LayoutStylesheet';
import Table from '../../common/PDF/Table';
import DateRange from '../../common/PDF/DateRange';
import EntityTablePDF from '../home/EntityTable/PDF';
import TerritoryTablePDF from '../home/Territories/PDF';
import VendorTablePDF from '../home/Vendor/PDF';
import DemographicsTablePDF from '../../common/Stats/Demographics/PDF';
import SourcesTablePDF from '../../common/Stats/Sources/PDF';
import DevicesTablePDF from '../../common/Stats/Devices/PDF';

export default (props) => {
    const { data: { images, tables, reportTitle, globalFilter, entity } } = props;
  return <Document>
    <Page size="A4" style={styles.page}>
    <View style={styles.columnReportTitle}>
      <Text style={styles.header}>{reportTitle}</Text>
      <Text style={styles.smallHeader}>{entity}</Text>
    </View>
    <DateRange filter={globalFilter} />
    <View style={styles.columnSection}>
      <View style={styles.column}>
        <Text style={styles.smallHeader}>Platforms</Text>
        <Image source={images.imprint_details_vendors} />
      </View>
      <View style={styles.column}>
        <Text style={styles.smallHeader}>Platforms</Text>
        <VendorTablePDF data={tables.vendorsTable} />
      </View>
    </View>
    <View style={styles.columnSection}>
      <View style={styles.columnWithMargin}>
          <Text style={styles.smallHeader}>Top Artists</Text>
          <EntityTablePDF entity="artists" data={tables.artists} />
      </View>
      <View style={styles.column}>
          <Text style={styles.smallHeader}>Top Artists</Text>
          <Image source={images.imprint_details_artists} />
      </View>
    </View>    
    <View style={styles.columnSection}>
      <View style={styles.column}>
        <Text style={styles.smallHeader}>Top Products</Text>
        <EntityTablePDF entity="products" data={tables.products} />
      </View>
      <View style={styles.column}>
          <Text style={styles.smallHeader}>Top Products</Text>
          <Image source={images.imprint_details_products} />
      </View>
    </View>
    <View style={styles.columnSection}>
      <View style={styles.column}>
          <Text style={styles.smallHeader}>Top Tracks</Text>
          <EntityTablePDF entity="tracks" data={tables.tracks} />
      </View>
      <View style={styles.column}>
          <Text style={styles.smallHeader}>Top Tracks</Text>
          <Image source={images.imprint_details_tracks} />
      </View>
    </View>  
    
    <View style={styles.columnSection}>
      <View style={styles.column}>
          <Text style={styles.smallHeader}>Top Playlists</Text>
          <EntityTablePDF entity="playlists" data={tables.playlists} />
      </View>
      <View style={styles.column}>
          <Text style={styles.smallHeader}>Top Playlists</Text>
          <Image source={images.imprint_details_playlists} />
      </View>
    </View>
  <View style={styles.columnSection}>
    <View style={styles.columnWithMargin}>
        <Text style={styles.smallHeader}>Age and Gender</Text>
        <Image source={images.imprint_details_demographics} />
    </View>
    <View style={styles.column}>
      <Text style={styles.smallHeader}>Age and Gender</Text>
      <DemographicsTablePDF data={tables.demograpics} />
    </View>
  </View>
  <View style={styles.columnSection}>
    <View style={styles.column}>
        <Text style={styles.smallHeader}>Territories</Text>
        <TerritoryTablePDF data={tables.territories} />
    </View>
  </View>
  <View style={styles.section}>
      <View style={styles.half}>
        <View style={styles.columnSection}>
            <View style={styles.columnWithMargin}>
              <Text style={styles.smallHeader}>Sources</Text>
              <Image source={images.imprint_details_sources} />
            </View>
            <View style={styles.column}>
              <Text style={styles.smallHeader}>Sources</Text>
              <SourcesTablePDF data={tables.sources} />
            </View>
        </View>
      </View>
      <View style={styles.half}>
        <View style={styles.columnSection}>
            <View style={styles.columnWithMargin}>
              <Text style={styles.smallHeader}>Devices</Text>
              <Image source={images.imprint_details_devices} />
            </View>
            <View style={styles.column}>
              <Text style={styles.smallHeader}>Devices</Text>
              <DevicesTablePDF data={tables.devices} />
            </View>
        </View>
      </View>
  </View>

  </Page>
  </Document>
};